
import RacingService from '@/biz/service/Racing/RacingService'
import DialogService from '@/service/DialogService/DialogService'
import RouterService from '@/service/RouterService'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ActionButtons extends Vue {
  @Prop()
  Service!: any

  private RouterService = RouterService
  private RacingService = RacingService
  private isShowTestBtns = process.env.VUE_APP_ENV === 'prod'

  // 月赛(2)/年赛(3): 显示"汇入晋级名单"手动兜底按钮
  get isPromotionRacing() {
    const level = RacingService.currentData.racing_level
    return level === 2 || level === 3
  }

  private handlePrintApplyTable() {
    return DialogService.show(require('../../RacingPrint/ApplyList.vue').default, {
      top: '7vh',
      width: '210mm'
    })
  }

  private handlePrintEmptyApplyTable() {
    return DialogService.show(require('../../RacingPrint/EmptyApply.vue').default, {
      top: '7vh',
      width: '210mm'
    })
  }

  private handlePrintInsureTable() {
    return DialogService.show(require('../../RacingPrint/Insure.vue').default, {
      top: '7vh',
      width: '210mm'
    })
  }

  private handleBatchCreate() {
    return DialogService.prompt({
      title: '添加数量'
    })
      .then((data: number) => this.Service.batchCreate(data))
      .then((res: any) => {
        this.$emit('reload', res)
        return res
      })
  }

  private handleBatchDestroy() {
    return this.Service.batchDestroy().then((res: any) => {
      this.$emit('reload', res)
      return res
    })
  }

  private handleBatchApplyClimbing() {
    return this.Service.batchApplyClimbing({
      racing_id: RouterService.query('racing_id'),
      racing_group_id: RouterService.query('racing_group_id')
    }).then((res: any) => {
      this.$emit('reload', res)
      return res
    })
  }

  private handleBatchPromote() {
    return this.Service.batchPromote({
      racing_id: RouterService.query('racing_id')
    }).then((res: any) => {
      this.$emit('reload', res)
      return res
    })
  }
}
